import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { UzurvPipesModule } from '@uzurv/core';
import { SubstanceScreeningComponent } from './substance-screening.component';

@NgModule({
  imports: [CommonModule, MatIconModule, UzurvPipesModule, MatButtonModule],
  exports: [SubstanceScreeningComponent],
  declarations: [SubstanceScreeningComponent]
})
export class SubstanceScreeningModule {}
